const RallyHighlightsSection = ({ highlights = [] }) => {
  const items = Array.isArray(highlights)
    ? highlights.map((item) => String(item || "").trim()).filter(Boolean)
    : [];

  return (
    <div className="mb-4">
      <h5 className="mb-3">Highlights</h5>
      {items.length === 0 ? (
        <p className="text-muted mb-0">No highlights added.</p>
      ) : (
        <ol className="mb-0 ps-3">
          {items.map((highlight, index) => (
            <li key={`${highlight}-${index}`} className="mb-2">
              {highlight}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default RallyHighlightsSection;
